/**
 * Trim content hook - removes whitespace from the beginning and end of an
 * element's content. Used primarily for whitespace-pre-line elements where the
 * content's output and appearance is directly impacted by the behavior of our
 * formatter. This has to be done in JS, because the displayed content is the
 * actual raw source, not just the templated Elixir values.
 */
const TrimContentHook = {
  mounted() {
    this.el.innerHTML = this.el.innerHTML.trim();
  },
};

export default TrimContentHook;
